import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { DsButton, DsIcon } from "../../../design-system";

export default function Modal({
  darkMode,
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  submitText,
  onCancel,
  hideSubmit = false,
  maxWidthClass = "max-w-md",
}) {
  if (!isOpen) return null;
  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100050] flex items-center justify-center bg-[hsl(var(--ds-fg)/0.45)] p-4 font-sans antialiased backdrop-blur-[2px]"
      role="presentation"
      onClick={onClose}
    >
      <div
        className={`relative w-full ${maxWidthClass} max-h-[90vh] overflow-y-auto rounded-[var(--ds-radius-lg)] border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] p-6 text-[hsl(var(--ds-fg))] shadow-[var(--ds-shadow-panel)]`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="ds-shared-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-md text-[hsl(var(--ds-muted-fg))] transition-colors hover:bg-[hsl(var(--ds-muted))] hover:text-[hsl(var(--ds-fg))] focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ds-ring))]"
          aria-label="Close"
        >
          <DsIcon icon={X} size="md" />
        </button>
        <h2 id="ds-shared-modal-title" className="ds-h3 mb-4 pr-8">
          {title}
        </h2>
        {children}
        <div className="mt-4 flex justify-end gap-2">
          {!hideSubmit && (
            <DsButton type="button" onClick={onSubmit}>
              {submitText}
            </DsButton>
          )}
          <DsButton type="button" variant="outline" onClick={onCancel}>
            {hideSubmit ? "Close" : "Cancel"}
          </DsButton>
        </div>
      </div>
    </div>,
    document.body
  );
}
